import { RouteName } from './types';

import {
    clampToManagerAssessmentStep,
    FIRST_STEP,
    getManagerAssessmentStepPath,
    LAST_STEP,
} from '@/pages/ManagerAssessment/Evaluation/stepRoutes';

interface EvaluationDestination {
    reviewInstanceId: string;
    cycleInstanceId: string;
    /**
     * A manager assessment only: the step its manager reached, and whether the questionnaire was
     * ever submitted. Left out for every other kind of evaluation.
     */
    managerAssessment?: { step: number; isSurveySubmitted: boolean; isMeetingCompleted: boolean };
}

/**
 * Where an employee's evaluation opens from a list. A manager assessment reopens on the step its
 * manager reached, and on the first one while nothing has been submitted -- its results page would
 * otherwise show the results of an autosaved draft, which has none. Every other kind opens on the
 * results page, which reads a review instance.
 */
export const evaluationDestination = ({
    reviewInstanceId,
    cycleInstanceId,
    managerAssessment,
}: EvaluationDestination): string => {
    if (!managerAssessment) {
        return `${RouteName.Eval360Results}/${reviewInstanceId}`;
    }

    // A held meeting closes the journey, so its line reopens on the last step whatever the stored
    // step says; otherwise the reached step, and the first one while nothing was ever submitted.
    if (managerAssessment.isMeetingCompleted) {
        return getManagerAssessmentStepPath(LAST_STEP, cycleInstanceId);
    }

    const reachedStep = managerAssessment.isSurveySubmitted
        ? clampToManagerAssessmentStep(managerAssessment.step)
        : FIRST_STEP;

    return getManagerAssessmentStepPath(reachedStep, cycleInstanceId);
};
